import React, { useEffect ,Suspense} from 'react'
import { BrowserRouter as Router, Routes, Route, Switch, Redirect } from "react-router-dom";
import { socketServices, Operation } from '../../services/socketServices'
import { useDispatch, useSelector } from 'react-redux'
import { Box ,Backdrop, CircularProgress } from "@mui/material"
import { styled, useTheme } from '@mui/material/styles';
import 'react-toastify/dist/ReactToastify.css';
import { getUserPermissions, getCentralTheming, setSocket } from '../../redux/actions';


const DrawerNavigate = React.lazy(() => import("../../views/Components/Drawer/Drawer"));
const GridView = React.lazy(() => import("../../views/Components/GridView/index.js"));
const StackMergeMovementSuggestionPage = React.lazy(() => import("../../views/Components/GridView/Components/GridMergeMovementSuggestionPage.js"));
const ThreeDView = React.lazy(() => import("../../views/Components/3dView/index.js"));

const TemplatesHome = React.lazy(() => import("../../views/Modules/Templates"));
const EditTemplate = React.lazy(() => import('../../views/Modules/Templates/EditTemplate'));
const CreateTemplate = React.lazy(() => import('../../views/Modules/Templates/CreateTemplate'));

const Inward = React.lazy(() => import('../../views/Modules/DataEntry/Inward/Inward'));
const AreaMapping = React.lazy(() => import('../../views/Components/AreaMapping/AreaMapping'));
const AreaSummary = React.lazy(() => import('../../views/Components/AreaSummary/index.js'));
const ViewTemplate = React.lazy(() => import('../../views/Modules/Templates/ViewTemplate'));
const GenericSlotBookingUI = React.lazy(() => import('../../views/Components/BookingSlot/CreateSlotBookingUI.js'));

//For SuperAdmin
const CompanyPage = React.lazy(() => import('../../views/Modules/SuperAdmin/Company/index.js'));
const AddCompany = React.lazy(() => import('../../views/Modules/SuperAdmin/Company/AddCompany.js'));
const WarehouseFloorPage = React.lazy(() => import('../../views/Modules/SuperAdmin/WarehouseFloor/index.js'));
const AddWarehouse = React.lazy(() => import('../../views/Modules/SuperAdmin/WarehouseFloor/Warehouse/AddWarehouse.js'));
const AddFloor = React.lazy(() => import('../../views/Modules/SuperAdmin/WarehouseFloor/Floor/AddFloor.js'));
const AddGridPage = React.lazy(() => import('../../views/Modules/SuperAdmin/Grid/addGrid.js'));
const AddAdmin = React.lazy(() => import('../../views/Modules/SuperAdmin/Users/Admin/AddAdmin.js'));
const AddWorker = React.lazy(() => import('../../views/Modules/SuperAdmin/Users/Worker/AddWorker.js'));
//dummy
const Map = React.lazy(() => import('../../views/Modules/BLE/Map/index'));
const AllInvetory = React.lazy(() => import('../../views/Modules/Inventory/Inventory/index.js'));
const QuantityControl = React.lazy(() => import('../../views/Modules/Inventory/QualityControl/index.js'));
const IdentificationConfig = React.lazy(() => import('../../views/Modules/Inventory/IdConfiguration'));
// for inventory adjustment
// for inventory adjustment
const InventoryAdjustments = React.lazy(() => import('../../views/Modules/Inventory/Adjustment/index.js'));
const AddAdjustment = React.lazy(() => import('../../views/Modules/DataEntry/Adjustment/AddAdjustment'));
const EditInventoryAdjustment = React.lazy(() => import('../../views/Modules/DataEntry/Adjustment/EditAdjustment'));

//Palletization Entry
const PalletizationEntry = React.lazy(() => import('../../views/Modules/DataEntry/Palletization/index.jsx'));
const MultiAsnReceiving = React.lazy(() => import('../../views/Modules/DataEntry/MultiASNReceiving/index.jsx'));
//Custom Dashboard
const CustomDashboard = React.lazy(() => import('../../views/Modules/CustomDashboard/index.jsx'));
const CreateCustomDashboard = React.lazy(() => import('../../views/Modules/CustomDashboard/CreateDashboard/CreateCustomDashboard.jsx'));
// for inventory journey
const ViewInventoryJourney = React.lazy(() => import('../../views/Modules/InventoryJourney/index.js'));
// For ASN
const AdvanceShipment = React.lazy(() => import('../../views/Modules/Inventory/ASN'));
const AddAsn = React.lazy(() => import('../../views/Modules/DataEntry/Asn/AddAsn'));
const ViewAsn = React.lazy(() => import('../../views/Modules/DataEntry/Asn/ViewAsn'));
const EditAsn = React.lazy(() => import('../../views/Modules/DataEntry/Asn/EditAsn'));
// For Kit
const KitAndBundle = React.lazy(() => import('../../views/Modules/DataEntry/KitAndBundle/index.js'));
const AddKit = React.lazy(() => import('../../views/Modules/DataEntry/KitAndBundle/AddKit.jsx'));
const ViewKit = React.lazy(() => import('../../views/Modules/DataEntry/KitAndBundle/ViewKit.js'));

//For In-house Palletization
const AddPallet = React.lazy(() => import('../../views/Modules/DataEntry/InhousePalletization/Palletization/AddPallet.jsx'));
const InHousePalletization = React.lazy(() => import('../../views/Modules/DataEntry/InhousePalletization/index.js'));
const ViewPallet = React.lazy(() => import('../../views/Modules/DataEntry/InhousePalletization/Palletization/ViewPallet.js'));
const EditPallet = React.lazy(() => import('../../views/Modules/DataEntry/InhousePalletization/Palletization/EditPallet.js'));

//For Quality Control
const QualityCheck = React.lazy(() => import('../../views/Modules/QualityControl/QualityCheck/index.js'));
const HygieneControl = React.lazy(() => import('../../views/Modules/QualityControl/HygieneControl/index.js'));
const Fumigation = React.lazy(() => import('../../views/Modules/QualityControl/Fumigation/index.js'));
const HygieneMaterial = React.lazy(() => import('../../views/Modules/QualityControl/HygieneMaterial/index.js'));
const ViewHygieneMaterial = React.lazy(() => import('../../views/Modules/QualityControl/HygieneMaterial/ViewHygieneMaterial.js'));

//For Notifications Settings
const NotificationsSettings = React.lazy(() => import('../../views/Modules/Settings/Notifications/index.js'));
const CreateNotification = React.lazy(() => import('../../views/Modules/Settings/Notifications/CreateNotification.js'));
const EditNotification = React.lazy(() => import('../../views/Modules/Settings/Notifications/EditNotification.js'));

const MainDashboard = React.lazy(() => import('../../views/Modules/MainDashboard'));
const Navigation = React.lazy(() => import('../../views/Modules/Navigation'));


// For Dispatch Planning 
const DispatchPlanning = React.lazy(() => import('../../views/Modules/SalesOrderProcessing/DispatchPlanning/index.js'));
const ViewDispatchPlan = React.lazy(() => import('../../views/Modules/SalesOrderProcessing/DispatchPlanning/ViewDispatchPlan.js'));

const JobModule = React.lazy(() => import('../../views/Modules/Jobs'));
const JobCreate = React.lazy(() => import('../../views/Modules/Jobs/JobCreation/index.js'));
const JobDetailViewPage = React.lazy(() => import('../../views/Modules/Jobs/JobView/JobDetailViewPage.js'));
const CreateUpdateJobType = React.lazy(() => import('../../views/Modules/Jobs/JobTypeDashboard/CreateUpdateJobType.js'));
const JobTypeView = React.lazy(() => import('../../views/Modules/Jobs/JobTypeDashboard/index'));
const UserManagement = React.lazy(() => import('../../views/Modules/UserManagement'));
const UserRole = React.lazy(() => import('../../views/Modules/UserManagement/UserRole/UserRole'));
const AddRole = React.lazy(() => import('../../views/Modules/UserManagement/UserRole/AddRole'));
const Workflow = React.lazy(() => import('../../views/Modules/Settings/Workflow'));
const AddWorkflow = React.lazy(() => import('../../views/Modules/Settings/AddWorkflow'));
const ItemMaster = React.lazy(() => import('../../views/Modules/EntityMaster/ItemMaster'));
const StockSummaryPage = React.lazy(()=> import('../../views/Modules/EntityMaster/StockSummaryPage.js'))
const CreateRuleAutomation = React.lazy(() => import('../../views/Modules/Settings/AutomationRules/CreateRuleAutomation/index'));
const AutomationRule = React.lazy(() => import('../../views/Modules/Settings/AutomationRules'));
const CreateSkuGroup = React.lazy(() => import('../../views/Modules/Settings/AutomationRules/CreateSkuGroup.js'));
const ReportDashboard = React.lazy(() => import('../../views/Modules/ReportMangement/index'));
const DownloadReport = React.lazy(() => import('../../views/Modules/ReportMangement/DownloadReport'));
const AddReturnProcess = React.lazy(() => import("../../views/Modules/DataEntry/Return/AddReturn.js"));
const AllReturnProcess = React.lazy(() => import("../../views/Modules/Inventory/StockReturn"));
const CreateSalesOrder = React.lazy(() => import('../../views/Modules/SalesOrderProcessing/createSalesOrder.js'));
const SalesOrderProcessing = React.lazy(() => import('../../views/Modules/SalesOrderProcessing/index.js'));
const ViewSales = React.lazy(() => import('../../views/Modules/SalesOrderProcessing/Component/ViewSales.js'));
const CreateDispatchOrder = React.lazy(() => import('../../views/Modules/SalesOrderProcessing/DispatchPlanning/CreateDispatchOrder.js'));
const PageNotFound = React.lazy(() => import('../../views/Landing/pageNotFound.js'));
// const InternalServerError = React.lazy(() => import('../../views/Landing/internalServerError.js'));
//INTEGRATION
const RFIDDashboard = React.lazy(() => import('../../views/Modules/RFID'));
const Trip = React.lazy(() => import('../../views/Modules/TMS/Trip/index.js'));
const TripDetail = React.lazy(() => import('../../views/Modules/TMS/Trip/tripDetail.js'));
const Addressbook = React.lazy(() => import('../../views/Modules/TMS/Addressbook/index.js'));
const AdminWorkerPage = React.lazy(() => import('../../views/Modules/SuperAdmin/Users/index.js'));
const ManageControls = React.lazy(() => import('../../views/Modules/Settings/AutomationRules/ManageControls/index.js'));
const PreviewCustomDashboard = React.lazy(() => import('../../views/Modules/CustomDashboard/PreviewDashboard/index.js'));
const CustomDashboardLanding = React.lazy(() => import('../../views/Modules/CustomDashboard/DefaultDashboard/index.js'));
const Checkpoint = React.lazy(() => import('../../views/Modules/Lynkid/Checkpoint/index.js'));
const CheckpointDashboard = React.lazy(() => import('../../views/Modules/Lynkid/Checkpoint/CheckpointDashboard.js'));
const ReportExploration = React.lazy(() => import('../../views/Modules/ReportMangement/ReportExploration/index.js'));
const ViewReportConfigPage = React.lazy(() => import('../../views/Modules/ReportMangement/ReportExploration/ViewReportConfigPage.js'));
const CreateViewQtyLabelPage = React.lazy(() => import('../../views/Modules/Inventory/Inventory/CreateViewQtyLabelPage.js'));
const CreateShipmentQtyLabelPage = React.lazy(() => import('../../views/Modules/Inventory/Inventory/CreateShipmentQtyLabelPage.js'));
const BullMQDashboard = React.lazy(() => import('../../views/Modules/BullMQDashboard'));

// Transactions
const MonthlyTransaction = React.lazy(() => import('../../views/Modules/MonthlyTransaction/index.js'));
const StatusChangeHistory = React.lazy(() => import('../../views/Modules/StatusChangeHistory/index.js'));
const ViewStatusHistoryPage = React.lazy(() => import('../../views/Modules/StatusChangeHistory/ViewStatusHistoryPage.js'));
const AutomationRuleBuilder = React.lazy(() => import('../../views/Modules/AutomationRule/Builder'));


const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));




function App(props) {
  const dispatch = useDispatch();
  // // const name = useSelector(state => state.auth.name)
  // const { userPermissions={},sidebarList=[]} = useSelector((state) => state.userPermission);
  let isFrameActive = !!localStorage.getItem("activeURL")
  const userData = localStorage?.getItem("user") && JSON.parse(localStorage?.getItem("user")) || {}
  const style = { flexGrow: 1, p: 3 }
  if (isFrameActive) {
    // style.position = "relative"
    // style.top = "-5px"
    style.pt = 0
    style.pl = 0
    style.pr = 0
  }
  const [isLoading, setIsLoading] = React.useState(true);
  const [userPermissions, setUserPermissions] = React.useState({});
  const [sidebarList, setSidebarList] = React.useState([]);
  const [configDetail, setConfigDetail] = React.useState({});

  const getRedirectPath = () => {
    let url = sidebarList?.at(0)?.subItems?.length > 0
      ? sidebarList?.at(0)?.subItems.at(0)?.url
      : sidebarList?.at(0)?.url

    // //("url",url)
    return url
  }
  useEffect(() => {
   
    setUserPermissions({})
    setSidebarList([])
    localStorage.removeItem("slotsBooked");
    dispatch(getUserPermissions({}, ({ data }) => {
   
      // console.log(data?.data?.permissions,'llll');
      setUserPermissions(data?.data || {})
      setSidebarList(data?.sidebarList || [])
      setConfigDetail(data?.configDetail || {})

      // Assuming you receive the permission response from the API
    }))


  }, [window?.location?.pathname])

  useEffect(() => {
    setIsLoading(true)
    dispatch(getCentralTheming({}, () => {
      setIsLoading(false);
    }))
  }, [])

  useEffect(() => {
    if (localStorage.getItem("token")) {
      var socket = socketServices()

      if (socket) {
        dispatch(setSocket(socket))
        socket.on("socket-change", socketData => {
          if (socketData && socketData?.data?.type) {
            // && ["ReportDownload","ParcelDimensions"].includes(socketData?.data?.type)
            Operation(socketData.data, dispatch)
          }
        });
      }
    }
    return () => {
      if (socket) {
        socket.disconnect()
      }
    };
  }, [window?.location?.pathname])

  return (
    <Suspense fallback={<Box>Loading...</Box>}>
      {
        isLoading
          ? <Backdrop
            sx={{ backgroundColor: 'rgba(0, 0, 0, 0)', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          :
          <Box sx={{ display: 'flex' }}>
            {!isFrameActive && <DrawerNavigate {...props} />}
            <Box component="main" sx={style}>
              {configDetail?.header?.visible && <DrawerHeader />}
              <Suspense fallback={<Box>Loading...</Box>}>
                <Switch>
                  {/* Superadmin route start */}
                  <Route exact path="/dashboard/grid/addGrid/:floorId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "manageFloorGrid",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/grid/addGrid/:floorId" render={() => <AddGridPage />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/grid/viewGrid/:floorId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "manageFloorGrid",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/grid/viewGrid/:floorId" render={() => <AddGridPage />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/company"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "createCompany",
                          "viewCompany",
                          "changeCompanyStatus",
                          "createWarehouse",
                          "viewWarehouse",
                          "changeWarehouseStatus",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/company" render={() => <CompanyPage />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/company/add"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "createCompany"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/company/add" render={() => <AddCompany />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/company/edit"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "createCompany",
                          "viewCompany",
                          "changeCompanyStatus",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/company/edit" render={() => <AddCompany />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/warehouseFloor"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "addWarehouse",
                          "viewWarehouse",
                          "changeWarehouseStaus",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/warehouseFloor" render={() => <WarehouseFloorPage />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/warehouse/add"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "addWarehouse",
                          "createCompany",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/warehouse/add" render={() => <AddWarehouse />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/warehouse/edit"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "editWarehouse",
                          "createCompany",

                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/warehouse/edit" render={() => <AddWarehouse />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/floor/add"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "addFloor",
                          "createCompany",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/floor/add" render={() => <AddFloor />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/floor/edit"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "editFloor",
                          "createCompany",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/floor/edit" render={() => <AddFloor />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/users"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "createCompany",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/users" render={() => <AdminWorkerPage />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/admin/add"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "addFloor",
                          "createCompany",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/admin/add" render={() => <AddAdmin />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/admin/edit"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "editFloor",
                          "createCompany",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/admin/edit" render={() => <AddAdmin />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/worker/add"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "addFloor",
                          "createCompany",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/worker/add" render={() => <AddWorker />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/worker/edit"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "editFloor",
                          "createCompany",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/worker/edit" render={() => <AddWorker />} />
                      </ProtectedRoute>
                    )}
                  />
                  {/* Superadmin route end */}
                  <Route exact path="/dashboard/addressBook"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "add_business_partners", "gstin_mandate",
                          "get_business_partners", "address_book", "request_referal",
                          "gstin_api", "manage_customer", "get_registered_address",
                          "view_transporter", "view_customer", "delete_customer",
                          "delete_transporter", "manage_transporter", "update_fav_partner",
                          "delete_fav_partner", "fav_partner_detail", "manage_customer",
                          "blacklist_vendor"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/addressBook" render={() => <Addressbook />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/trip"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "create_trip",
                          "update_trip",
                          "get_trips"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/trip" render={() => <Trip />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/trip/trip-detail"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "create_trip",
                          "update_trip",
                          "get_trips"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/trip/trip-detail" render={() => <TripDetail />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/view-checkpoint-dashboard"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "getDashboardV2"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/view-checkpoint-dashboard" render={() => <Checkpoint />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/checkpoint-dashboard"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "getDashboardV2"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/checkpoint-dashboard" render={() => <CheckpointDashboard />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["dashboard"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard" render={() => <MainDashboard />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/view-Default-dashboard"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewDefaultDashboard"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/view-Default-dashboard" render={() => <CustomDashboardLanding />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route exact path="/dashboard/view-custom-dashboard"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewCustomDashboard", "createCustomDashboard", "updateCustomDashboard", "changeCustomDashboardStatus", "deleteCustomDashboard"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/view-custom-dashboard" render={() => <CustomDashboard />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/create-custom-dashboard"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["createCustomDashboard"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/create-custom-dashboard" render={() => <CreateCustomDashboard />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/custom/view/:dashboardID"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["createCustomDashboard"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/custom/view/:dashboardID" render={() => <PreviewCustomDashboard />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/setting/manage-workflows"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewWorkFlowList', "viewWorkFlowDetail", 'AddWorkFlow', "editWorkFlow", "enableDisableWorkFlow", "deleteWorkFlow"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/setting/manage-workflows" render={() => <Workflow />} />
                      </ProtectedRoute>
                    )} />
                  <Route exact
                    path="/dashboard/report-management"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewReportDashboard', 'inwardReport', 'inventorySummaryReport', 'itemMasterReport', 'inwardSummaryReport',
                          'outwardSummaryReport', 'stockTransferReport', 'areaWiseStockSummaryReport', 'dayWiseIrStockReport', 'IrStockSummaryReport',
                          'IrClosingStockReport', 'areaWiseSKUSummaryReport', 'cellwiseAreaUtilizationReport', 'ASNReceivingReport', 'inventoryAgeReport',
                           'readyToDispatchMovementTrackingReport','orderPendencyReport','hygieneJobReport','generalFumigationReport','classificationReport','orderFulfillmentReport']}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/report-management" render={() => <ReportDashboard />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact
                    path="/dashboard/report-exploration"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewReportConfigs"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/report-exploration" render={() => <ReportExploration />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route exact
                    path="/dashboard/report-create-config"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['createNewReportConfig']}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/report-create-config" render={() => <DownloadReport />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/report-view-config/:reportId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewReportConfigs"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/report-view-config/:reportId" render={() => <ViewReportConfigPage />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact
                    path="/dashboard/report-Download"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['downloadReport']}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/report-Download" render={() => <DownloadReport />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/monthly-transaction"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "getMonthlyTransaction"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/monthly-transaction" render={() => <MonthlyTransaction />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route exact path="/dashboard/status-history"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "viewStatusHistory"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/status-history" render={() => <StatusChangeHistory />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/view-status-history/:entityId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewStatusHistory"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/view-status-history/:entityId" render={() => <ViewStatusHistoryPage />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/salesOrder"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "createSalesOrder",
                          "editSalesOrder",
                          "allocateSalesOrder",
                          "rejectSalesOrder",
                          "approveSalesOrder",
                          "viewSalesOrder",
                          "viewDetailSalesOrder",
                          "moveToInspection",
                          "createPreShipmentInspectionJob",
                          "createMoveToFumigationJob",
                          "addMoreStockToInspection",
                          "createMoveToStackJob"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/salesOrder" render={() => <SalesOrderProcessing />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/createSalesOrder"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "createSalesOrder", "viewSalesOrder", "viewDetailSalesOrder", "moveToInspection", "createPreShipmentInspectionJob", "createMoveToFumigationJob",
                          "createMoveToStackJob"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/createSalesOrder" render={() => <CreateSalesOrder />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/view-Sales/:salesId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewSalesOrder", "viewDetailSalesOrder", "moveToInspection", "createPreShipmentInspectionJob", "createMoveToFumigationJob", "addMoreStockToInspection",
                          "createMoveToStackJob"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/view-Sales/:salesId" render={() => <ViewSales />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/create-dispatch-plan"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewSalesOrder", "viewDetailSalesOrder"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/create-dispatch-plan" render={() => <CreateDispatchOrder />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/bookSlot"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["bookSlot"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/bookSlot" render={() => <GenericSlotBookingUI />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route
                    exact
                    path="/dashboard/dispatchPlanning"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewDispatchPlan", "createDispatchPlan"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/dispatchPlanning" render={() => <DispatchPlanning />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route exact path="/dashboard/dispatchPlanning/view-plan/:dispatchId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewDispatchPlan"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/dispatchPlanning/view-plan/:dispatchId" render={() => <ViewDispatchPlan />} />
                      </ProtectedRoute>
                    )}
                  />

                  {/* <Route exact path="/dashboard/salesOrder" render={() => <SalesOrderProcessing />} />
                      <Route exact path="/dashboard/createSalesOrder" render={() => <CreateSalesOrder />} />
                      <Route exact path="/dashboard/view-Sales/:salesId" render={() => <ViewSales />} /> */}


                  <Route exact path="/dashboard/setting/create-workflow"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['AddWorkFlow', "editWorkFlow"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/setting/create-workflow" render={() => <AddWorkflow />} />
                      </ProtectedRoute>
                    )} />

                  <Route exact path="/dashboard/setting/edit-workflow/:workflowId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewItemMaster', "addItemMaster", 'deleteItemMaster', "updateItemMaster"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/setting/edit-workflow/:workflowId" render={() => <AddWorkflow />} />
                      </ProtectedRoute>
                    )} />


                  <Route exact path="/dashboard/entity-master/item-master"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewItemMaster', "addItemMaster", 'deleteItemMaster', "updateItemMaster"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/entity-master/item-master" render={() => <ItemMaster />} />
                      </ProtectedRoute>
                    )} />
                  <Route exact path="/dashboard/entity-master/kit-master"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['addKitMaster', "deleteKitMaster", 'updateKitMaster', "viewKitMaster"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/entity-master/kit-master" render={() => <ItemMaster />} />
                      </ProtectedRoute>
                    )} />
                  <Route exact path="/dashboard/entity-master/pallet-master"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewPalletMaster', "addPalletMaster", 'deletePalletMaster', "updatePalletMaster"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/entity-master/pallet-master" render={() => <ItemMaster />} />
                      </ProtectedRoute>
                    )} />
                  <Route exact path="/dashboard/entity-master/service-master"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewServiceMaster', "addServiceMaster", 'deleteServiceMaster', "updateServiceMaster"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/entity-master/service-master" render={() => <ItemMaster />} />
                      </ProtectedRoute>
                    )} />
                  <Route exact path="/dashboard/entity-master/customer-master"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewCustomerMaster', "addCustomerMaster", 'deleteCustomerMaster', "updateCustomerMaster"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/entity-master/customer-master" render={() => <ItemMaster />} />
                      </ProtectedRoute>
                    )} />

                  <Route exact path="/dashboard/entity-master/supplier-master"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewSupplierMaster', "addSupplierMaster", 'deleteSupplierMaster', "updateSupplierMaster"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/entity-master/supplier-master" render={() => <ItemMaster />} />
                      </ProtectedRoute>
                    )} />
                  <Route exact path="/dashboard/entity-master/stock-summary"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewStockSummaryPage"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/entity-master/stock-summary" render={() => <StockSummaryPage />} />
                      </ProtectedRoute>
                    )} />

                  <Route exact path="/dashboard/data/view-journey"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewInventoryJourneyItemMaster", "viewInventoryJourneyKitMaster"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/view-journey" render={() => <ViewInventoryJourney />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route exact path="/dashboard/setting/automation-rules"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewAutomationRule', 'createAutomationRule', 'createSKUPlacementRules',
                          'deleteSKUPlacementRules', 'viewSKUPlacementRules'
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/setting/automation-rules" render={() => <AutomationRule />} />
                      </ProtectedRoute>
                    )} />

                  <Route exact path="/dashboard/setting/automation-rules/CreateRuleAutomation"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['createAutomationRule']}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/setting/automation-rules/CreateRuleAutomation" render={() => <CreateRuleAutomation />} />
                      </ProtectedRoute>
                    )} />

                  <Route exact path="/dashboard/setting/automation-rules/createSKUPlacementRule"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['createSKUPlacementRules']}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/setting/automation-rules/createSKUPlacementRule" render={() => <CreateSkuGroup />} />
                      </ProtectedRoute>
                    )} />
                  <Route exact path="/dashboard/setting/manage-controls"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['ViewProcessControls', 'updateProcessControls']}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/setting/manage-controls" render={() => <ManageControls />} />
                      </ProtectedRoute>
                    )} />

                  <Route exact path="/dashboard/setting/notifications"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['createNotificationSetting', 'updateNotificationSetting', 'deleteNotificationSetting',
                          'viewNotificationSetting',
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/setting/notifications" render={() => <NotificationsSettings />} />
                      </ProtectedRoute>
                    )} />
                  <Route exact path="/dashboard/setting/notifications/createNotification"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['createNotificationSetting']}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/setting/notifications/createNotification" render={() => <CreateNotification />} />
                      </ProtectedRoute>
                    )} />
                  <Route exact path="/dashboard/setting/notifications/editNotification/:moduleId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["updateNotificationSetting"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/setting/notifications/editNotification/:moduleId" render={() => <EditNotification />} />
                      </ProtectedRoute>
                    )} />

                  <Route
                    exact
                    path="/dashboard/data/inward"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['asnReceiving', "addNewInventory"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/inward" render={() => <Inward />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/data/multi-asn-receiving"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['asnReceiving', "addNewInventory", "packingListReceiving"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/multi-asn-receiving" render={() => <MultiAsnReceiving />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/data/load-stock"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["loadInventory"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/load-stock" render={() => <MultiAsnReceiving />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/inventory/palletization"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['singlePackageDataEntry']}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/palletization" render={() => <PalletizationEntry />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route
                    exact
                    path="/dashboard/inventory/asn"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewASN', "createASN", "deleteASN", "updateASN", "acceptRejectASN", "asnReceiving","verifyStockTransferReceiving"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/asn" render={() => <AdvanceShipment />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route
                    exact
                    path="/dashboard/inventory/kit"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewKit', "createKit", "acceptRejectKit"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/kit" render={() => <KitAndBundle />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/data/kit"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewKit', "createKit", "acceptRejectKit"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/kit" render={() => <AddKit />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/data/view-kit/:kitId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewKit', "createKit", "acceptRejectKit"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/view-kit/:kitId" render={() => <ViewKit />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route
                    exact
                    path="/dashboard/inventory/inhouse-palletization"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['createInhousePallet', "editInhousePallet", "viewInhousePallet", "palletizationInitiation", "palletizationApproval", "viewDismantleInhousePallet", "dismantlePalletInitiation", "dismantlePalletApproval"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/inhouse-palletization" render={() => <InHousePalletization />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/data/inhouse-palletization"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["createInhousePallet",]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/inhouse-palletization" render={() => <AddPallet />} />
                      </ProtectedRoute>
                    )} />

                  <Route exact path="/dashboard/data/edit-pallet/:compId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["editInhousePallet"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/edit-pallet/:compId" render={() => <EditPallet />} />
                      </ProtectedRoute>
                    )} />

                  <Route exact path="/dashboard/data/view-pallet/:palletId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['dismantlePalletApproval', "createInhousePallet", "palletizationApproval"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/view-pallet/:palletId" render={() => <ViewPallet />} />
                      </ProtectedRoute>
                    )}
                  />


                  <Route exact path="/dashboard/data/asn"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["createASN"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/asn" render={() => <AddAsn />} />
                      </ProtectedRoute>
                    )} />
                  <Route exact path="/dashboard/data/view-asn/:asnId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewASN', "createASN", "deleteASN", "updateASN", "acceptRejectASN", "asnReceiving","verifyStockTransferReceiving"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/view-asn/:asnId" render={() => <ViewAsn />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/data/edit-asn/:compId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["updateASN"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/edit-asn/:compId" render={() => <EditAsn />} />
                      </ProtectedRoute>
                    )} />
                  <Route
                    exact
                    path="/dashboard/data/create-adjustment/:adjustmentCardType"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['createInventoryAdjustment', 'createSkuAdjustment']}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/create-adjustment/:adjustmentCardType" render={() => <AddAdjustment />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/data/edit-adjustment/:refNo"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['updateInventoryAdjustment']}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/edit-adjustment/:refNo" render={() => <EditInventoryAdjustment />} />
                      </ProtectedRoute>
                    )}
                  />
                  {/* Inventory Table URLS */}

                  <Route
                    exact
                    path="/dashboard/inventory/all"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['addNewInventory', "viewInventory", "viewInventoryDetails", "deleteInventory"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/all" render={() => <AllInvetory />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/inventory/generateQtyWiseLabel"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['addNewInventory', "viewInventory", "viewInventoryDetails", "deleteInventory"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/generateQtyWiseLabel" render={() => <CreateViewQtyLabelPage />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/inventory/generateShipmentQtyWiseLabel"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['addNewInventory', "viewInventory", "viewInventoryDetails", "deleteInventory"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/generateShipmentQtyWiseLabel" render={() => <CreateShipmentQtyLabelPage />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/inventory/qualityControl"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['addNewInventory', "viewInventory", "viewInventoryDetails", "deleteInventory"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/qualityControl" render={() => <QuantityControl />} />
                      </ProtectedRoute>
                    )}
                  />


                  <Route
                    exact
                    path="/dashboard/inventory/adjustments"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "viewInventoryAdjustment",
                          "viewAsnAdjustment",
                          "viewSkuAdjustment",
                          "viewQcAdjustment"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/adjustments" render={() => <InventoryAdjustments />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/inventory/add-return"
                    render={() => (
                      <ProtectedRoute
                        // permissionId={['allReturns', "addReturns"]}
                        redirectPath={getRedirectPath()}
                      // userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/add-return" render={() => <AddReturnProcess />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route
                    exact
                    path="/dashboard/inventory/returns"
                    render={() => (
                      <ProtectedRoute
                        // permissionId={['viewASN', "createASN", "deleteASN", "updateASN", "acceptRejectASN"]}
                        // permissionId={['allReturns', "addReturns"]}
                        redirectPath={getRedirectPath()}
                      // userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/returns" render={() => <AllReturnProcess />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route
                    exact
                    path="/dashboard/inventory/configuration"
                    render={() => (
                      <ProtectedRoute
                        permissionId={['viewIdentifier', "updateIdentifier"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/inventory/configuration" render={() => <IdentificationConfig />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route
                    exact
                    path="/dashboard/templates/edit/:templateId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["editTemplate"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/templates/edit/:templateId" render={() => <EditTemplate />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/templates/view/:templateId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewTemplate", "createTemplate", "deleteTemplate", "editTemplate", "enabledisableTemplate"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/templates/view/:templateId" render={() => <ViewTemplate />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/templates/create"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["createTemplate"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/templates/create" render={() => <CreateTemplate />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/templates"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewTemplate", "createTemplate", "deleteTemplate", "editTemplate", "enabledisableTemplate"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/templates" render={() => <TemplatesHome />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/jobs/create-job"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["createNewJob", "createPickPackJob", "createPutAwayJob", "createStockTranferJob",
                          "createReturnSellerJob", "createDispatchJob", "completeDispatchJob",
                          "completeReturnSellerJob", "completeStockTranferJob", "completePutAwayJob",
                          "completePickPackJob", "createInwardPackingJob", "completeInwardPackingJob"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/jobs/create-job" render={() => <JobCreate />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/jobs/create-job-type"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["createNewJob", "createPickPackJob", "createPutAwayJob", "createStockTranferJob",
                          "createReturnSellerJob", "createDispatchJob", "completeDispatchJob",
                          "completeReturnSellerJob", "completeStockTranferJob", "completePutAwayJob",
                          "completePickPackJob"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/jobs/create-job-type" render={() => <CreateUpdateJobType />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/jobs/edit-job-type/:jobTypeId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["createNewJob", "createPickPackJob", "createPutAwayJob", "createStockTranferJob",
                          "createReturnSellerJob", "createDispatchJob", "completeDispatchJob",
                          "completeReturnSellerJob", "completeStockTranferJob", "completePutAwayJob",
                          "completePickPackJob"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/jobs/edit-job-type/:jobTypeId" render={() => <CreateUpdateJobType />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/job/viewJobTypes"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewJobType", "addJobType", "deleteJobType", "editJobType"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/job/viewJobTypes" render={() => <JobTypeView />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/jobs"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "viewJobType", "addJobType", "deleteJobType", "editJobType", "viewAllJobs", "viewJobDetails",
                          "createNewJob", "viewPendency", "createPickPackJob", "createPutAwayJob", "createStockTranferJob",
                          "createReturnSellerJob", "createDispatchJob", "completeDispatchJob", "completeReturnSellerJob",
                          "completeStockTranferJob", "completePutAwayJob", "completePickPackJob",
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/jobs" render={() => <JobModule />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/view-job/:jobId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewJobDetails"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/view-job/:jobId" render={() => <JobDetailViewPage />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/area/grid"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewGrid", "generateGridQR", "exportPTPMData", "viewPTPWReading"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/area/grid" render={() => <GridView />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/area/grid/stack-merge-movement-suggestions"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewGrid", "generateGridQR", "exportPTPMData", "viewPTPWReading"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/area/grid/stack-merge-movement-suggestions" render={() => <StackMergeMovementSuggestionPage />} />
                      </ProtectedRoute>
                    )}
                  />
                  {/* <Route
                    exact
                    path="/dashboard/area/3d"
                    render={() => <ThreeDView />}
                  /> */}
                  <Route
                    exact
                    path="/dashboard/area/3d"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewThreeDimentionalGrid"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/area/3d" render={() => <ThreeDView />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/area/mapping"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewAreaMapping", "allocateArea", "viewDockMapping", "createDockMapping", "updateDockMapping", "deleteDockMapping"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/area/mapping" render={() => <AreaMapping />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/area/summary"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewAreaSummaryPage"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/area/summary" render={() => <AreaSummary />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/BLE/map"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewBleTracking"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/BLE/map" render={() => <Map />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/RFID"
                    render={() => (
                      <ProtectedRoute
                        permissionId={[
                          "addTag",
                          "deleteTag",
                          "getTag",
                          "updateTag"
                        ]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/RFID" render={() => <RFIDDashboard />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/user_management/my-team"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewTeamMembers", "addNewMember", "editTeamMember", "disableEnableTeamMember", "deleteTeamMember"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/user_management/my-team" render={() => <UserManagement />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/user_management/user-role"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["addRole", "disableEnableUserRole", "viewUserRoles", "editRole", "createAdmin", "viewAdmin", "changeAdminStatus"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/user_management/user-role" render={() => <UserRole />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/user_management/:roleAction"
                    render={() => (
                      <ProtectedRoute
                        permissionId={window?.location?.pathname.split('/').includes("edit-role") ? ["addRole", "createAdmin", "viewAdmin", "changeAdminStatus"] : ["editRole", "createAdmin", "viewAdmin", "changeAdminStatus"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/user_management/:roleAction" render={() => <AddRole />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/quality-control/quality-check"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewQualityCheck", "createInHouseQualityCheckJob", "createInwardQualityCheckJob"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/quality-control/quality-check" render={() => <QualityCheck />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/quality-control/hygiene-control"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["createMistingJob", "createBeetleMonitoringJob", "createFoggingJob", "createHardSurfaceSprayingJob", "viewHygieneControl"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/quality-control/hygiene-control" render={() => <HygieneControl />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/quality-control/fumigation"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewFumigation", "createReceiptFumigationJob", "createShipmentFumigationJob", "createCyclicFumigationJob"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/quality-control/fumigation" render={() => <Fumigation />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route
                    exact
                    path="/dashboard/quality-control/hygiene-material"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["createHygieneMaterial", "editHygieneMaterial", "viewHygieneMaterial", "approveRejectHygieneMaterial", "bulkUploadHygieneMaterial", "mappingHygieneMaterial", "replaceHygieneMaterial"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/quality-control/hygiene-material" render={() => <HygieneMaterial />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/data/view-hygiene-material/:materialId"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewHygieneMaterial"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                      >
                        <Route exact path="/dashboard/data/view-hygiene-material/:materialId" render={() => <ViewHygieneMaterial />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/view-bullmq-dashboard"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["viewBullMQDashboard"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                        userData={userData}
                        currentpath="/dashboard/view-bullmq-dashboard"
                      >
                        <Route exact path="/dashboard/view-bullmq-dashboard" render={() => <BullMQDashboard />} />
                      </ProtectedRoute>
                    )}
                  />
                  <Route exact path="/dashboard/automation-rule-builder"
                    render={() => (
                      <ProtectedRoute
                        permissionId={["automationRuleBuilder"]}
                        redirectPath={getRedirectPath()}
                        userPermissions={userPermissions}
                        userData={userData}
                        currentpath="/dashboard/automation-rule-builder"
                      >
                        <Route exact path="/dashboard/automation-rule-builder" render={() => <AutomationRuleBuilder />} />
                      </ProtectedRoute>
                    )}
                  />

                  <Route
                    exact
                    path="/dashboard/navigation"
                    render={() => <Navigation />}
                  />
                  {/* <Route
                      exact
                      path="/error"
                      render={() => <InternalServerError />}
                    /> */}
                  <Route component={PageNotFound} />
                  <Redirect to={getRedirectPath() || "/dashboard"} />
                </Switch>
              </Suspense>
            </Box>
          </Box >
      }
    </Suspense>
  );
}

export default App;

const ProtectedRoute = ({ permissionId, redirectPath = "/", userPermissions,userData={}, children,currentpath="" }) => {

  if (currentpath == "/dashboard/view-bullmq-dashboard") {
    if (/superadmin/i.test(userData?.userType)) {
      return children;
    }
    else {
      return <Redirect to={redirectPath} replace />;
    }
  }
  let condition = false
  if (userPermissions?.permissions?.length > 0) {
    condition = true
  }

  if (!condition) {
    return children;
  }
  else {
    let vaild_perm = permissionId.some(key => userPermissions.permissions.some(permission => permission.permissionId === key))

    if (vaild_perm) {
      return children;
    }
    else {
      return <Redirect to={redirectPath} replace />;
    }
  }
};
